<script setup>
import {onMounted, onUnmounted, ref} from "vue";
import {fadeHide, fadeShow} from "@straylightagency/animate";
import {easeInOutExpo} from "@straylightagency/animate/easing";
import {addEventListeners, getElementSizing, unlessElementExists, whenResize} from "@straylightagency/utils/dom";

const {testimonies} = defineProps({ testimonies: Object } );
const testimonialEl = ref();
const index = ref(0);
const testimonial = ref(testimonies[0]);

let previousEvents = null, nextEvents = null, cleanup = null;

onMounted( () => {
    [, cleanup] = whenResize( ({ww}) => {
        if ( ww >= 1280 ) {
            let {height} = getElementSizing( testimonialEl.value );

            testimonialEl.value.parentNode.style.height = height > 0 ? height + "px" : null;
        } else {
            testimonialEl.value.parentNode.style.height = 'auto';
        }
    } );

    unlessElementExists('#previousTestimonial', previousButton => {
        previousEvents = addEventListeners( previousButton, {
            async click() {
                index.value = index.value === 0 ? index.value = testimonies.length - 1 : index.value - 1;

                await fadeHide( testimonialEl.value, 500, easeInOutExpo );
                testimonial.value = testimonies[ index.value ];
                await fadeShow( testimonialEl.value, 500, easeInOutExpo );
            }
        } );
    } );

    unlessElementExists('#nextTestimonial', nextButton => {
        nextEvents = addEventListeners( nextButton, {
            async click() {
                index.value = index.value === testimonies.length - 1 ? index.value = 0 : index.value + 1;

                await fadeHide( testimonialEl.value, 500, easeInOutExpo );
                testimonial.value = testimonies[ index.value ];
                await fadeShow( testimonialEl.value, 500, easeInOutExpo );
            }
        } );
    } );
} );

onUnmounted( () => {
    previousEvents && previousEvents.click();
    nextEvents && nextEvents.click();
    cleanup && cleanup();
} );
</script>

<template>
    <div ref="testimonialEl">
        <blockquote class="quotes | text-white text-2xl italic mb-10" v-html="testimonial.content"></blockquote>

        <div class="flex flex-row gap-x-5">
            <img :src="testimonial.picture" :alt="testimonial.name" class="rounded-full w-24 h-24 block">

            <p class="flex flex-col justify-center gap-y-2">
                <strong class="font-display text-white">{{ testimonial.name }}</strong>
                <cite class="text-pale-gold">{{ testimonial.function }} de {{ testimonial.company }}</cite>
            </p>
        </div>

        <span class="corner-top-left corner-top-right"></span>
        <span class="corner-bottom-left corner-bottom-right"></span>
    </div>
</template>